export const DEFAULT_CORNER_STYLE = 'classic'
export const DEFAULT_FONT_PAIRING = 'classic'
export const DEFAULT_HERO_LAYOUT = 'classic'
export const INHERIT_HERO_LAYOUT = 'inherit'

export const cornerStyleOptions = [
  { id: 'square', name: 'Square' },
  { id: 'classic', name: 'Classic' },
  { id: 'soft', name: 'Soft' },
  { id: 'rounded', name: 'Rounded' },
]

export const fontPairingOptions = [
  { id: 'classic', name: 'Classic' },
  { id: 'clean', name: 'Clean' },
  { id: 'romantic', name: 'Romantic' },
  { id: 'friendly', name: 'Friendly' },
  { id: 'professional', name: 'Professional' },
]

export const heroLayoutOptions = [
  { id: 'classic', name: 'Classic' },
  { id: 'split', name: 'Split' },
  { id: 'professional', name: 'Professional' },
]

export const inheritedHeroLayoutOption = {
  id: INHERIT_HERO_LAYOUT,
  name: 'Keep florist style',
}

export const heroLayoutOptionsWithInherited = [inheritedHeroLayoutOption, ...heroLayoutOptions]

export const heroTextPositionOptions = [
  { id: 'left', name: 'Left' },
  { id: 'center', name: 'Center' },
  { id: 'right', name: 'Right' },
]

export const heroTextToneOptions = [
  { id: 'auto', name: 'Automatic' },
  { id: 'light', name: 'Light text' },
  { id: 'dark', name: 'Dark text' },
]

export const getHeroTextPositionOptions = (layout) =>
  layout === 'split'
    ? heroTextPositionOptions.filter((option) => option.id !== 'center')
    : heroTextPositionOptions

export const resolveHeroTextPosition = ({ layout, position, focalPointX = 50 }) => {
  const isSupportedPosition = heroTextPositionOptions.some((option) => option.id === position)

  if (isSupportedPosition) {
    return layout === 'split' && position === 'center' ? 'right' : position
  }

  // Older hero blocks have no placement field. Match their storefront fallbacks so
  // merely opening and saving an existing design cannot move its copy.
  if (layout === 'split') {
    return 'right'
  }

  if (layout === 'professional') {
    const normalizedFocalPointX =
      focalPointX == null || focalPointX === '' || !Number.isFinite(Number(focalPointX))
        ? 50
        : Number(focalPointX)

    return normalizedFocalPointX < 50 ? 'right' : 'left'
  }

  return 'center'
}

export const resolveOptionId = (value, options, fallback) =>
  options.some((option) => option.id === value) ? value : fallback
